<template>
  <div class="product-container">
    <div class="product-hd">
      <van-sticky offset-top="21.867vw">
        <van-tabs
          v-model="active"
          line-height="0"
          title-active-color="#c30d23"
          background="#efefef"
          @change="onTabChange"
        >
          <van-tab v-for="(item, i) in categories" :title="item.title" :key="i" />
        </van-tabs>
      </van-sticky>
    </div>

    <van-list
      ref="list"
      loading-text="加载中..."
      v-model="loading"
      :finished="finished"
      :immediate-check="false"
      @load="loadProducts"
    >
      <div class="product-list">
        <div class="product-column" v-for="(v, k) in products" :key="k">
          <router-link
            class="product-column-item"
            v-for="(vv, kk) in v"
            :key="kk"
            :to="{
              path: '/mall/detail',
              query: {
                id: vv.id,
                storeId: vv.salesStoreIds ? vv.salesStoreIds.split(',')[0] : ''
              }
            }"
          >
            <van-image
              lazy-load
              fit="cover"
              width="100%"
              height="44.675vw"
              radius="2.133vw"
              :src="vv.mainPictureUrl"
              :alt="vv.title"
            />
            <div class="product-column-item-title van-multi-ellipsis--l2">
              {{ vv.title }}
            </div>
            <div class="product-column-item-price-box">
              <span class="product-column-item-price-box--price"> ￥{{ vv.minPrice }} </span>
              <strike v-if="vv.minPrice < vv.price"> ￥{{ vv.price }} </strike>
              <span class="product-column-item-price-box--discount" v-if="vv.discount > 0 && vv.discount < 10">
                {{ vv.discount }}折
              </span>
            </div>
          </router-link>
        </div>
      </div>

      <div slot="finished">
        <div v-if="products.length > 0 && products[0].length > 0">
          到底啦~
        </div>
        <van-empty v-else :image="require('@/assets/images/puhui/sy-w5.png')" description="暂无商品" />
      </div>
    </van-list>
  </div>
</template>

<script>
import { PRODUCT_ENQUIRY } from '@/config/platformtype'
import { summaryInformation } from '@/api/productsDetaile'

export default {
  name: 'ProductPanel',
  data() {
    return {
      categories: [
        {
          id: 0,
          title: '精选',
          desc: '猜你喜欢'
        },
        {
          id: 1,
          title: '美食',
          desc: '胃你优选'
        },
        {
          id: 4,
          title: '生活',
          desc: '居家日用'
        },
        {
          id: 3,
          title: '休闲',
          desc: '猜让身心歇会'
        },
        {
          id: 5,
          title: '亲子',
          desc: '养娃那些事'
        }
      ],
      active: 0,
      products: [],
      pageNum: 1,
      loading: false,
      finished: false,
      list: []
    }
  },
  methods: {
    onLoad() {
      console.log('onload')
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1)
        }

        // 加载状态结束
        this.loading = false

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true
        }
      }, 1000)
    },
    /**
     * 加载产品列表
     */
    loadProducts() {
      const params = {
        current: this.pageNum,
        size: 10,
        platform: PRODUCT_ENQUIRY
      }
      if (this.active !== 0) {
        params.topCategoryId = this.categories[this.active].id
      }
      summaryInformation(params).then(res => {
        const result = res.data.data
        const records = result.records

        if (!this.products[0]) {
          this.products[0] = []
        }
        if (!this.products[1]) {
          this.products[1] = []
        }

        let i = 0
        while (i < records.length) {
          this.products[0].push(records[i++])
          if (i < records.length) {
            this.products[1].push(records[i++])
          }
        }

        this.loading = false
        this.finished = result.current >= result.pages

        if (this.pageNum++ === 1) {
          this.$refs.list.$el.scrollIntoViewIfNeeded(false)
        }
      })
    },

    /**
     * 切换产品分类导航
     */
    onTabChange(index) {
      this.finished = false
      this.pageNum = 1
      this.products = []
      this.$refs.list.check()
    }
  }
}
</script>

<style lang="less" scoped>
.product {
  &-container {
    margin: 12px 8px 5px 8px;
    border-radius: 8px;
    background-color: #efefef;
    overflow: hidden;
  }

  &-hd {
    height: 50px;
  }

  &-list {
    display: flex;
    flex-direction: row;
  }

  &-column {
    display: flex;
    flex-direction: column;
    flex: 1;

    &:first-child {
      padding: 0 4px 0 8px;
    }

    &:last-child {
      padding: 0 8px 12px 4px;
    }

    &-item {
      height: 250px;
      margin-bottom: 12px;
      border-radius: 8px;
      background-color: #fff;
      overflow: hidden;
      position: relative;

      &-title {
        margin: 8px;
        color: #3e3a39;
        font-size: 15px;
        font-weight: 400;
      }

      &-price-box {
        position: absolute;
        bottom: 8px;
        left: 8px;
        right: 8px;
        color: #898989;
        font-size: 12px;

        &--price {
          color: #c30d23;
          font-size: 14px;
          font-weight: 600;
        }

        &--discount {
          margin-left: 10px;
        }
      }
    }
  }
}

/deep/ .van-empty {
  &__image {
    width: 100px;
    height: 100px;
    text-align: center;

    img {
      width: auto;
      height: auto;
    }
  }
}
</style>
